import { useMutation, useQuery } from '@tanstack/react-query';
import {
  deleteExternalFormLogo,
  generateExternalFormLink,
  getExternalForm,
  getExternalFormShareLink,
  updateExternalForm,
  uploadExternalFormLogo,
} from '@/features/externalForm/services/externalFormService';

const BASE = 'externalForm';

export const externalFormQueryKeys = {
  detail: () => [BASE],
};

export const useGetExternalForm = () => {
  return useQuery({
    queryKey: externalFormQueryKeys.detail(),
    queryFn: getExternalForm,
  });
};

export const useUpdateExternalForm = () => {
  return useMutation({
    mutationFn: updateExternalForm,
  });
};

export const useUploadExternalFormLogo = () => {
  return useMutation({
    mutationFn: uploadExternalFormLogo,
  });
};

export const useDeleteExternalFormLogo = () => {
  return useMutation({
    mutationFn: deleteExternalFormLogo,
  });
};

export const useGenerateExternalFormLink = () => {
  return useMutation({
    mutationFn: generateExternalFormLink,
  });
};

export const useGetExternalFormShareLink = () => {
  return useQuery({
    queryKey: [...externalFormQueryKeys.detail(), 'shareLink'],
    queryFn: getExternalFormShareLink,
    retry: false,
  });
};
